import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DirtyStateService {
  private dirty = new BehaviorSubject(false);
  isDirty() {
    return this.dirty.getValue();
  }
  setDirty() {
    this.dirty.next(true);
  }
  clear() {
    this.dirty.next(false);
  }
}
